var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboard-table__heading"},_vm._l((_vm.headingItems),function(headingItem){return _c('div',{key:headingItem.text,staticClass:"leaderboard-table__heading-cell"},[_vm._v("\n    "+_vm._s(headingItem.text)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }